let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("dyRLq")).then(() => parcelRequire('fmx3D'));